// docs: https://github.com/altostra/type-validations#readme
import { objectOf, arrayOf, enumOf, maybe } from "@altostra/type-validations";
import { number, string, boolean } from "@altostra/type-validations/lib/primitives";

export const isEngagementInAppMessageCampaignsAndWorkflowsDataResult = objectOf({
  hits: number,
  results: arrayOf(
    objectOf({
      name: string,
      id: string,
      is_draft: boolean,
      is_active: boolean,
      priority_bucket: number,
      priority: number,
      type: enumOf("campaign", "canvas"),
      is_pinned: maybe(boolean),
    })
  ),
});
